/**
 * Await a dispatched thunk, rejecting when its API call failed. `dispatch(thunk)` resolves to the
 * thunk's action and carries `unwrap`, but the store's dispatch typing doesn't expose it.
 */
export const unwrap = (dispatched: unknown) => (dispatched as { unwrap: () => Promise<unknown> }).unwrap();
